export enum JobTaskStatusType {
  OPEN = 0,
  SCHEDULED = 1,
  IN_PROGRESS = 2,
  PART_COMPLETED = 3,
  COMPLETED = 4,
  CANCELLED = 5
}

export const JobTaskStatusTypeLabel = {
  [JobTaskStatusType.OPEN]: 'Open',
  [JobTaskStatusType.SCHEDULED]: 'Scheduled',
  [JobTaskStatusType.IN_PROGRESS]: 'In Progress',
  [JobTaskStatusType.PART_COMPLETED]: 'Part Completed',
  [JobTaskStatusType.COMPLETED]: 'Completed',
  [JobTaskStatusType.CANCELLED]: 'Cancelled'
}
